import messagesApi from '@/services/messages/messages';

export default {
  getMessageRoleConfigurations({ commit }) {
    return messagesApi.getRoleConfigurations()
      .then(response => {
        commit('SET_INACTIVE_CTX_LOCK', response.data.hasInactiveContextLock);
      })
      .catch(error => Promise.reject(error.response.data.error));
  }
};
